"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = enforceFunction;

function enforceFunction(operation, index) {
  if (typeof operation === 'function') {
    return operation;
  }

  var name = typeof index === 'number' ? "operation[" + index + "]" : 'operation';
  throw new Error("expected `" + name + "` to be a function but got `" + String(operation) + "`");
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.11/internal/_enforceFunction.js
// module id = 806
// module chunks = 209 210 211 212